module.exports = __webpack_public_path__ + "static/media/2b.7ed619c0.svg";